import styled from 'styled-components';

const SectionHeader = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--dark-04-color);
  margin-bottom: 8px;
`;

export default SectionHeader;
